import React from 'react'

import styled from 'styled-components'
import { useDebouncedCallback } from 'use-debounce'

import Play2Icon from 'src/Assets/Svg/play-2.svg?react'
import { DEBOUNCE_DELAY_100 } from 'src/Constants/constants'
import { variables } from 'src/Styled/variables'

export interface PlayButtonProps {
  text?: string
  disabled?: boolean
  className?: string
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
}

const StyledPlayButton = styled.button<{ $hasText: boolean }>`
  && {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: ${({ $hasText }) => ($hasText ? '6px 12px' : '6px')};
    border-radius: 8px;
    border: 1px solid ${({ theme }) => theme.color.lightGreen};
    background: ${({ theme }) => theme.color.lightGreen};
    color: ${({ theme }) => theme.color.darkGreen};
    cursor: pointer;
    transition: all 0.2s;

    font-family: 'Segoe UI';
    font-size: ${variables.fontSize14};
    font-style: normal;
    font-weight: ${variables.fontWeight400};
    line-height: 150%;

    svg {
      flex-shrink: 0;
      width: 16px;
      height: 16px;
    }

    &:hover {
      background: ${({ theme }) => theme.color.lightGrey};
      border-color: ${({ theme }) => theme.color.lightGrey};
      color: ${({ theme }) => theme.color.darkGrey};
    }

    &:focus-visible {
      outline: none;
      background: ${({ theme }) => theme.color.hoverWhite};
      border-color: ${({ theme }) => theme.color.darkGreen};
      color: ${({ theme }) => theme.color.darkGreen};
    }

    &:active {
      background: ${({ theme }) => theme.color.hoverWhite};
      border-color: ${({ theme }) => theme.color.lightGrey};
      color: ${({ theme }) => theme.color.slateGrey};
    }

    &:disabled {
      cursor: not-allowed;
      background: ${({ theme }) => theme.color.hoverWhite};
      border-color: ${({ theme }) => theme.color.lightGrey};
      color: ${({ theme }) => theme.color.lightGrey};
    }
  }
`

export const PlayButton: React.FC<PlayButtonProps> = ({
  text,
  disabled,
  className,
  onClick,
}) => {
  const debouncedOnClick = useDebouncedCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      if (typeof onClick === 'function') {
        onClick(event)
      }
    },
    DEBOUNCE_DELAY_100,
  )

  return (
    <StyledPlayButton
      $hasText={Boolean(text)}
      disabled={disabled}
      className={className}
      onClick={(e) => debouncedOnClick(e)}
    >
      <Play2Icon />
      {text && <span>{text}</span>}
    </StyledPlayButton>
  )
}
